<template>
    <div class="audio-bar">
        <div class="cover">
            <el-image :src="cover" fit="contain"></el-image>
            <button v-if="audioData.path" :class="['icon-button', !isPlay ? 'stop' : 'play']" :disabled="loading || isUpload"
                @click.prevent="onPaly()"></button>
        </div>
        <div class="content">
            <div class="text">
                {{ audioData.name }}<br />
                {{ durationFormat }} / {{ audioData.duration }}
            </div>
            <div class="button">
                <div class="point"></div>
                <el-button v-if="!showDelete" type="primary" @click="onEdit">重新上传</el-button>
                <el-button v-else type="danger" @click="onDelete">删除</el-button>
            </div>
        </div>
        <el-slider v-if="audioData.path" v-model="sliderValue" :show-tooltip="false" @mousedown.native="userSeeking = true"
            @mouseup.native="userSeeking = false" @change="changeAudioTime" :min="0" :max="sliderMax"></el-slider>
    </div>
</template>

<script>
import { fetchAudioXcodeUrl } from '@/api/file';
import musicwavBg from '@/assets/img/upload/musicwav_bg@2x.png';
export default {
    props: {
        audioData: {
            type: Object,
            default: () => { }
        },
        showDelete: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            cover: musicwavBg,
            loading: false,
            audio: new Audio(),
            isPlay: false,
            sliderValue: 0,
            duration: 0,
            sliderMax: 1000,
            userSeeking: false,
            lastUrl: '',
            durationFormat: '00:00:00'
        }
    },
    watch: {
        audioData: {
            immediate: true,
            handler(audioData) {
                if (audioData && audioData.path) {
                    this.getAudioUrl(audioData.path);
                } else {
                    this.setPaly(false, false);
                    this.durationFormat = '00:00:00';
                    this.sliderValue = 0;
                }
            }
        }
    },
    computed: {
        isUpload() {
            const { audioData } = this;
            if (audioData && audioData.loading) return true;
            return false;
        }
    },
    mounted() {
        this.setAudioEvent();
    },
    beforeDestroy() {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
    },
    methods: {
        setAudioEvent() {
            const { audio } = this;
            audio.onerror = () => {
                this.setPaly(false, false);
                this.$message.error('音频文件播放错误');
            }
            audio.ontimeupdate = () => {
                if (this.userSeeking) return;
                if (audio && audio.currentTime) {
                    const currentTime = Number(audio.currentTime.toFixed(3));
                    this.sliderValue = parseInt((currentTime / this.duration) * this.sliderMax);
                    this.durationFormat = this.$utils.formatTime(audio.currentTime);
                }
            }
            audio.oncanplay = () => {
                this.duration = audio.duration;
            };
            audio.onloadstart = () => {
                this.setPaly(true, false);
            }
            audio.onpause = () => {
                this.setPaly(false, false);
            }
            audio.onended = () => {
                this.setPaly(false, false);
            }
        },
        async getAudioUrl(path) {
            if (!path || this.lastUrl === path) return;
            this.lastUrl = path;
            this.loading = true;
            const res = await fetchAudioXcodeUrl(path);
            const { state, result } = res.data;
            if (!state) {
                this.loading = false;
                return this.$message.error('解析音频文件异常');
            }
            this.loadAudio(result);
        },
        loadAudio(url) {
            this.audio.src = url;
            this.audio.load();
            this.loading = false;
        },
        changeAudioTime(value) {
            const { duration, audio, sliderMax } = this;
            if (duration > 0 && audio) {
                const currentTime = (value * duration) / sliderMax;
                this.audio.currentTime = currentTime;
            }
        },
        setPaly(isPlay = null, loading = null) {
            this.isPlay = isPlay;
            this.loading = loading;
        },
        onPaly() {
            if (this.loading || !this.audioData.path) return;
            const { isPlay } = this;
            if (isPlay) {
                this.audio.play();
            } else {
                this.audio.pause();
            }
            this.setPaly(!isPlay, false);
        },
        onEdit() {
            this.$emit('onEdit', true);
        },
        onDelete() {
            this.$emit('onDelete', true);
        }
    },
}
</script>

<style lang="scss">
.audio-bar {
    position: absolute;
    z-index: 2;
    top: 0px;
    width: 100%;
    display: flex;
    align-items: center;
    background: $--input-background-color;

    .cover {
        width: 148px;
        height: 148px;
        position: relative;

        .el-image {
            width: 100%;
            height: 100%;
        }

        .icon-button {
            width: 32px;
            height: 32px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -16px;
            margin-top: -16px;
            background-size: cover !important;
            border: none;
            cursor: pointer;

            &.play {
                background: url('~@/assets/img/upload/wav_play.svg') no-repeat center;
            }

            &.stop {
                background: url('~@/assets/img/upload/wav_stop.svg') no-repeat center;
            }
        }
    }



    .content {
        margin: 0 20px;
        flex: 1;

        .text {
            line-height: 30px;
        }

        .button {
            align-items: center;
            display: none;

            .point {
                flex: 1;
                position: relative;
                height: 4px;
                overflow: hidden;
                margin-right: 10px;

                &::before {
                    content: "..............";
                    position: absolute;
                    top: -10px;
                    left: 0px;
                    color: $-text-950;
                    line-height: 16px;
                    font-weight: bold;
                    font-size: 16px;
                    letter-spacing: 3px;
                }
            }
        }
    }

    .el-slider {
        position: absolute;
        width: 100%;
        bottom: -16px;
        left: 0px;

        .el-slider__runway {
            height: 2px;

            .el-slider__bar {
                height: 2px;
                background-color: $--color-base;
            }

            .el-slider__button-wrapper {
                width: 6px;
                height: 6px;
                top: -10px;

                .el-slider__button {
                    width: 4px;
                    height: 4px;
                    border: solid 2px $--color-base;
                }
            }
        }
    }

    &:hover {
        .content {
            .text {
                display: none;
            }

            .button {
                display: flex;
            }
        }
    }
}
</style>
